import { CLOSE_LOADER } from 'action-types';

export default function () {
  return {
    type: CLOSE_LOADER,
  };
}
